import { Route, Routes } from 'react-router-dom'
import Vera from 'subdomains/Vera'

export const veraRoutes = {
  subdomain: 'vera',
  routes: () => (
    <Routes>
      <Route path='/' element={<Vera />} />
    </Routes>
  ),
}
